import { render, staticRenderFns } from "./AdmineCharts.vue?vue&type=template&id=8a1b09fc&"
import script from "./AdmineCharts.vue?vue&type=script&lang=js&"
export * from "./AdmineCharts.vue?vue&type=script&lang=js&"
import style0 from "./AdmineCharts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports